import { useQuery } from 'react-query';
import Comment from '../../../models/Comment';

function useCommentsById(taskId?: string) {
    return useQuery<Comment[]>(['comments/list/', taskId], { enabled: !!taskId });
}

export default useCommentsById;
